import { Link } from "react-router-dom";
import useTranslation from "@babackapp/translations/use-translation";
import { ResetPasswordForm } from "@/pages/(auth)/reset-password/components/reset-password-form.tsx";
import logoColors from "@/assets/logo-colors.png";

export const ResetPassword = () => {
  const t = useTranslation();

  return (
    <div className="min-h-full h-lvh bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="mx-auto w-full max-w-sm lg:w-96">
        <div>
          <img className="h-12 w-auto" src={logoColors} alt="Baback" />
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            {t("forgotPwd.title")}
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            {t("misc.or")} <Link to={`/app/sign-in`}>{t("login.login")}</Link>
          </p>
        </div>
      </div>
      <ResetPasswordForm />
    </div>
  );
};
